import React from "react";

function Catagories({ categories }) {
  return (
    <div className="widget">
      <h4 className="sidebar-title">Categorías</h4>
      <div className="sidebar-cat-list">
        <ul>
          {Array.isArray(categories) && categories.length > 0
            ? categories.map((category) => (
                <li className="sidebar-cat-list-li" key={category._id}>
                  <a href="/#">{category.title}</a>
                </li>
              ))
            : null}
        </ul>
      </div>
    </div>
  );
}

export default Catagories;
